export const WorkflowOverlayContentComponent: React.FC<React.PropsWithChildren & { className?: string }> = (props) => {
    const { className, children } = props;

    return <div className={`workflow-content ${className}`}>{children}</div>;
};
